import React from 'react';
import PropTypes from 'prop-types';
import Navigation from './components/Navigation/Navigation';
import Grid from './components/Grid/Grid';
import Brands from './components/Brands/Brands';
import Checkout from './components/Checkout/Checkout';
import Legal from './components/Legal/Legal';
import argos from './config/argos/argos';
import habitat from './config/habitat/habitat';
import tu from './config/tu/tu';
import * as Styled from './Footer.styles';
var brands = {
  argos: argos,
  habitat: habitat,
  tu: tu
};

var Footer = function Footer(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$navigationHidden = _ref.navigationHidden,
      navigationHidden = _ref$navigationHidden === void 0 ? false : _ref$navigationHidden,
      _ref$gridHidden = _ref.gridHidden,
      gridHidden = _ref$gridHidden === void 0 ? false : _ref$gridHidden,
      _ref$brandHidden = _ref.brandHidden,
      brandHidden = _ref$brandHidden === void 0 ? false : _ref$brandHidden,
      _ref$legalHidden = _ref.legalHidden,
      legalHidden = _ref$legalHidden === void 0 ? false : _ref$legalHidden,
      _ref$creditHidden = _ref.creditHidden,
      creditHidden = _ref$creditHidden === void 0 ? false : _ref$creditHidden,
      _ref$nativeLazy = _ref.nativeLazy,
      nativeLazy = _ref$nativeLazy === void 0 ? false : _ref$nativeLazy,
      _ref$dataTest = _ref['data-test'],
      dataTest = _ref$dataTest === void 0 ? 'component-footer' : _ref$dataTest,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$brand = _ref.brand,
      brand = _ref$brand === void 0 ? 'habitat' : _ref$brand,
      _ref$checkoutLogosTyp = _ref.checkoutLogosType,
      checkoutLogosType = _ref$checkoutLogosTyp === void 0 ? 'payment' : _ref$checkoutLogosTyp,
      _ref$paypalCreditHidd = _ref.paypalCreditHidden,
      paypalCreditHidden = _ref$paypalCreditHidd === void 0 ? true : _ref$paypalCreditHidd;
  var brandConfig = brands[brand.toLowerCase()] || {};
  var _brandConfig$navigati = brandConfig.navigation,
      navigation = _brandConfig$navigati === void 0 ? [] : _brandConfig$navigati,
      grid = brandConfig.grid,
      brandItems = brandConfig.brands,
      legal = brandConfig.legal,
      paypalCredit = brandConfig.paypalCredit;
  return Object.keys(brandConfig).length !== 0 && /*#__PURE__*/React.createElement(Styled.Footer, {
    type: type,
    "data-test": dataTest,
    brand: brand
  }, type === 'default' ? /*#__PURE__*/React.createElement(React.Fragment, null, !navigationHidden && /*#__PURE__*/React.createElement(Navigation, {
    navigation: navigation
  }), !gridHidden && grid && /*#__PURE__*/React.createElement(Grid, {
    nativeLazy: nativeLazy,
    grid: grid(nativeLazy)
  }), !brandHidden && /*#__PURE__*/React.createElement(Brands, {
    nativeLazy: nativeLazy,
    brands: brandItems
  }), !legalHidden && /*#__PURE__*/React.createElement(Legal, {
    creditHidden: creditHidden,
    onClick: onClick,
    legal: legal,
    paypalCreditHidden: paypalCreditHidden,
    paypalCredit: paypalCredit,
    paypalExampleHidden: true,
    showCarePolicy: true
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkout, {
    nativeLazy: nativeLazy,
    brands: brandItems,
    checkoutLogosType: checkoutLogosType
  }), /*#__PURE__*/React.createElement(Legal, {
    creditHidden: creditHidden,
    onClick: onClick,
    legal: legal,
    paypalCreditHidden: paypalCreditHidden,
    paypalCredit: paypalCredit
  })));
};

Footer.propTypes = {
  /**
   * Either default of checkout footer
   */
  type: PropTypes.oneOf(['default', 'checkout']),

  /**
   * If navigation/primary section should not be rendered
   */
  navigationHidden: PropTypes.bool,

  /**
   * If grid/secondary section should not be rendered
   */
  gridHidden: PropTypes.bool,

  /**
   * If brand section should not be rendered
   */
  brandHidden: PropTypes.bool,

  /**
   * If legal section should not be rendered
   */
  legalHidden: PropTypes.bool,

  /**
   * If credit section should not be rendered
   */
  creditHidden: PropTypes.bool,

  /**
   * Optionally, for SSR, set to {true} to avoid using <InView/>
   */
  nativeLazy: PropTypes.bool,

  /**
   * Specify the brand name
   */
  brand: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Footer for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Optional prop to pass through onClick events when legal footer links are clicked
   */
  onClick: PropTypes.func,

  /**
   * Optional prop to toggle the logos on the checkout footer
   */
  checkoutLogosType: PropTypes.oneOf(['payment', 'brand']),
  paypalCreditHidden: PropTypes.bool
};
export var legalText = {
  ARGOS: argos.legal.legalText,
  HABITAT: habitat.legal.legalText
};
export var paypalLegalText = {
  ARGOS: argos.paypalCredit,
  HABITAT: habitat.paypalCredit
};
export default Footer;